import * as React from "react";
import {
    Policy,
    Renewal,
    PREMIUM_TYPE_MONTHLY,
    RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
    SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED
} from "@falcon/services";
import {formatDateDMY, getAmountToDisplay} from "../../CommonFunctions";
import {Link} from "react-router-dom";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

interface IAutoRenewalProps {
    currentPolicy: Policy;
    renewalProposal: Renewal;
    showHideWillBeRenewedConfirmation: (display: boolean) => void;
    setPerformRenewal: (a: boolean) => void;
    hideCloseButton?: boolean;
    onClose?: () => void;
}

interface IAutoRenewalState {
    isOpen: boolean;
}

export class GracePeriodModal extends React.Component<IAutoRenewalProps, IAutoRenewalState> {

    constructor(props: IAutoRenewalProps) {
        super(props);

        this.state = {
            isOpen: true
        };
    }

    public render() {
        const {make, model, registrationNumber} = this.props.currentPolicy.insuredVehicles[0];
        const renewalStartDate = formatDateDMY(this.props.renewalProposal.headerInfo.startDate);
        const premiumType: string = this.props.renewalProposal.factors.premiumType;

        const annualRenewalPrice: number = this.props.renewalProposal.factors.annualPremium;
        const annualLastYearPrice: number = this.props.currentPolicy.interaction.factors.annualPremium;

        const monthlyRenewalPrice: number = this.props.renewalProposal.paymentDetails.instalmentPlan.monthlyPayment;
        const monthlyLastYearPrice: number = this.props.currentPolicy.interaction.factors.monthlyPremium;
        return (
            <>
                {
                    <Modal className="my-2 manual-renewal-modal" isOpen={this.state.isOpen} toggle={() => this.hideModal(true)}>
                        <ModalHeader close={<button className="btn-close" onClick={() => this.hideModal(true)}/>}/>
                        <ModalBody className={`pt-0 `}>
                            <div>
                                <p>
                                    <h1 className="m-0 pb-20">{this.props.currentPolicy.policyHolder.firstName},</h1>
                                    <p className="m-0 pt-20">
                                        <span>You are no longer covered.</span> Your <strong>car policy for your {make} {model} ({registrationNumber}) ended on {renewalStartDate}</strong>.
                                    </p>
                                    <p className="pb-20">
                                        <span className="font-weight-bold">It’s not too late to renew now</span>
                                    </p>
                                    <div className="renewal-price-comparison">
                                        <div className="d-flex w-100 justify-content-between">
                                            <div className="d-flex flex-column w-auto justify-content-center">
                                                <span className="font-weight-bold m-0">Renewal price</span>
                                                {premiumType === PREMIUM_TYPE_MONTHLY && <span>You will pay {getAmountToDisplay(monthlyRenewalPrice)} / month</span>}
                                            </div>
                                            <div
                                                className="d-flex w-auto justify-content-end align-items-center">
                                                <h5 className="font-weight-bold m-0">{getAmountToDisplay(annualRenewalPrice)}</h5>
                                            </div>
                                        </div>
                                        <div className="d-flex w-100 justify-content-between">
                                            <div className="d-flex flex-column w-auto">
                                                <span className="font-weight-bold">Last year's price</span>
                                                {premiumType === PREMIUM_TYPE_MONTHLY && <span className="pt-6">You paid {getAmountToDisplay(monthlyLastYearPrice)} / month</span>}
                                            </div>
                                            <div
                                                className="d-flex w-auto justify-content-end align-items-center">
                                                <h3 className="font-weight-bold m-0">{getAmountToDisplay(annualLastYearPrice)}<sup>*</sup></h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="last-year-price-explanation">
                                        <span><sup>*</sup>&nbsp;Including any changes made</span>
                                        <span>All figures include Insurance Premium Tax.</span>
                                    </div>
                                    <p className="font-weight-bold">
                                        Please take a minute to have a good read of your&nbsp;
                                        <Link className="color-cyan-blue"
                                              to={`/dashboard/annualMotorDocuments/${this.props.currentPolicy.policyNumber}`}>
                                            <span className="hyperlink">renewal documents</span>
                                        </Link>
                                        , just to make sure all your details are correct.
                                    </p>
                                </p>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <div className="d-flex flex-column w-100">
                                <Link
                                    className="btn btn-primary btn-blue-dashboard"
                                    to={RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.props.renewalProposal!._id}
                                    onClick={this.setRenewal}>Renew your policy now
                                </Link>
                                {!this.props.hideCloseButton && <button type="button" className="btn btn-white-dashboard"
                                                                        onClick={() => this.hideModal(true)}>Not just yet
                                </button>}
                            </div>
                        </ModalFooter>
                    </Modal>
                }

            </>
        )
    }

    private setRenewal = (): void => {
        this.props.showHideWillBeRenewedConfirmation(true);
        this.hideModal(false);
    }

    private hideModal = (executeOnClose: boolean): void => {
        if (this.props.onClose && executeOnClose) {
            this.props.onClose();
        }

        window.sessionStorage.setItem(SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED + this.props.currentPolicy.policyNumber, "true");
        this.setState({
            isOpen: false
        });
    }

}



// WEBPACK FOOTER //
// ./src/components/modals/GracePeriodModal.tsx